import img from '../../../img/news/quantum_computing_maeil.jpg';

export const metadata = {
  title: "The Future of Computer Vision Technology Lies in Quantum Computing",
  date: "May 1, 2025",
  link: "https://www.mk.co.kr/en/it/11306767",
  image: img,
  excerpt: `
            It is also important to use it to prepare for the era of quantum computers. Kim Jun-sung, CEO of Qblack AI, who left 
            a large company and started his business last month, is looking for the future of his business in quantum computers. 
            CEO Kim researches the field of computer vision, which takes more than 30 minutes each to process data with the current 
            technology. CEO Kim said, "Since there are tens of thousands of data to be processed, it is competitive to introduce 
            quantum computers quickly".
            `,
  alt: "QblackAI's vision on compuer vision and quantum computing"
};